export enum FileUploadStatus {
  /**
   *
   */
  EMPTY = 'EMPTY',

  /**
   * Represents a file that is currently being loaded or uploaded.
   */
  LOADING = 'LOADING',

  /**
   * Represents a file upload that has failed.
   */
  FAILED = 'FAILED',

  /**
   * Represents a canceled file upload.
   */
  CANCELED = 'CANCELED',
}

/**
 * Properties for the FileUpload component.
 */
export type FileUploadProps = {
  /**
   * The status of the file upload.
   */
  status: FileUploadStatus;

  /**
   * Specifies whether the file upload is disabled.
   */
  isDisabled?: boolean;
};
